module.exports = require('./dist/apollo-client/client');
